/*@ngInject*/
const UnpublishChatMessageRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.unpublishChatMessage = function (chatMessageId) {
        let url = '/rest/ChatMessage/' + chatMessageId + '/unpublish';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('unpublishChatMessageRepository', UnpublishChatMessageRepository);
